import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import {FormSendType, OwnershipTransferActionType} from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import Config from '../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import vIcon from '../Icons/v.svg';

const SuccessPageTwoForms = (props) => {
  const styledNumber = (number) => {
    return number?.replace(/^(.{3})(.*)$/, '$1-$2');
  };

  const lTitle = () => {
    if (props.data.selectedActionType === OwnershipTransferActionType.PrivateToBusiness) {
      return props.data.subscriberSendFormType.type === FormSendType.sms
        ? `טופס לחתימה נשלח בהצלחה למנוי <span class='no-wrap'>${styledNumber(props.data.subscriberSendFormType.sms)}</span>`
        : `טופס לחתימה נשלח  ${!props.resendForms ? 'שוב' : 'בהצלחה'} לכתובת המייל שהזנת
           <div className='email'>${props.data.subscriberSendFormType.email}</div>`;
    } else {
      return props.data.contactPersonSendFormType.type === FormSendType.sms
        ? `טופס לחתימה שלך נשלח בהצלחה למספר <span class='no-wrap'>${styledNumber(props.data.contactPersonSendFormType.sms)}</span>`
        : `טופס לחתימה שלך נשלח ${!props.resendForms ? 'שוב' : 'בהצלחה'} לכתובת המייל שהזנת
           <div className='email'>${props.data.contactPersonSendFormType.email}</div>`;
    }
  };

  const mTitle = () => {
    if (props.data.selectedActionType === OwnershipTransferActionType.PrivateToBusiness) {
      return props.data.contactPersonSendFormType.type === FormSendType.sms
        ? `טופס לחתימה שלך יישלח למספר <span class='no-wrap'>${styledNumber(
            props.data.contactPersonSendFormType.sms,
          )}</span> לשם השלמת התהליך`
        : `טופס לחתימה שלך יישלח למייל <br /> לשם השלמת התהליך
           <div className='email'>${props.data.contactPersonSendFormType.email}</div>`;
    } else {
      return props.data.subscriberSendFormType.type === FormSendType.sms
        ? `טופס לחתימה של המנוי יישלח למספר <span class='no-wrap semi'>${styledNumber(
            props.data.subscriberSendFormType.sms,
          )}</span> לשם השלמת התהליך`
        : `טופס לחתימה יישלח למייל של מנוי מספר <span class='no-wrap semi'>${styledNumber(
            props.data.selectedPhoneNumber,
          )}</span> לשם השלמת התהליך
        <div className='email'>${props.data.subscriberSendFormType.email}</div>`;
    }
  };

  const getCpMessage = () => {
    if (props.data.selectedActionType == OwnershipTransferActionType.PrivateToBusiness) {
      if (props.data.jetConnection) {
        return `על המנוי לחתום על הטופס בהקדם, רק לאחר חתימה שלו תתקבל בקשה לחתימה של איש הקשר על הטופס. לאחר השלמת החתימות המנוי יוכל להמשיך בתהליך העברת הבעלות.`;
      } else {
        return `על המנוי לחתום על הטופס בהקדם, רק לאחר חתימה שלו תקבל בקשה לחתימה שלך על הטופס. לאחר השלמת החתימות המנוי יוכל להמשיך בתהליך העברת הבעלות.`;
      }
    } else {
      if (props.data.jetConnection) {
        return `על איש הקשר לחתום על הטופס בהקדם כדי לאפשר למנוי להתחיל בתהליך. רק לאחר חתימתו תישלח למנוי בקשה לחתימה על הטופס שלו.`;
      } else {
        return `עליך לחתום על הטופס בהקדם כדי לאפשר למנוי להתחיל בתהליך. רק לאחר חתימתך תישלח למנוי בקשה לחתימה על הטופס שלו.`;
      }
    }
  };
  return (
    <div className='stepContainer'>
      <Image src={vIcon} />
      <div className='l-title' dangerouslySetInnerHTML={{__html: lTitle()}}></div>
      <div className='m-title' dangerouslySetInnerHTML={{__html: mTitle()}}></div>
      <div className='cp-message'>
        <div className='m-sub-title' dangerouslySetInnerHTML={{__html: getCpMessage()}} />
      </div>
      <div className='continue-button'>
        <BtnSubmit text={isMobile ? 'להעברת קו נוסף' : 'לצפייה בכל העברות הבעלות'} onclick={() => props.nextStepSuccessPage()} />
        <BtnWhiteBlackBorderBigSize text={'לאזור האישי'} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPageTwoForms);
